import React from 'react';
import { Colors, Flex, IconTimer, Typography } from '@banhala/ui-kit';
import { TimerText } from './TimerText';
import { BottomDockedNudgeBannerContainer } from './BottomDockedNudgeBannerContainer';

type TimeSaleBannerProps = {
  title: string;
  finishedAt: string;
};

export const TimeSaleBanner: React.FC<TimeSaleBannerProps> = ({
  title,
  finishedAt,
}) => {
  return (
    <BottomDockedNudgeBannerContainer>
      <Flex.Row
        alignItems={'center'}
        height={36}
        justifyContent={'center'}
        backgroundColor={'pink5'}
        gap={4}
      >
        <IconTimer size={16} fill={Colors.content_pink_primary} />
        <Typography type={'body3'}>{title}</Typography>
        <TimerText finishedAt={finishedAt} />
      </Flex.Row>
    </BottomDockedNudgeBannerContainer>
  );
};
